export const countPlaces = (places) => {
    let count = 0;
    for (let i = 0; i < places.length; i++) {
        count++;
        if (places[i].child_places.length > 0) {
            count += countPlaces(places[i].child_places);
        }
    }
    return count;
}